import React from "react";
import "./review.tokens.scss";
import "./ReviewPageLayout.scss";

/**
 * Unified review shell: max-width, optional stepper, then either integrated grid or free children.
 * Presentational only.
 *
 * @param {React.ReactNode} [stepper]
 * @param {React.ReactNode} [main] — used when sidebar is set (two-column desktop)
 * @param {React.ReactNode} [sidebar] — sticky aside on large screens
 * @param {React.ReactNode} [children] — when main/sidebar omitted, full-width flow below stepper
 * @param {string} [className]
 */
export default function ReviewPageLayout({ stepper, main, sidebar, children, className = "" }) {
  const integrated = main != null && sidebar != null;

  return (
    <div className={`review-ds review-page-layout${className ? ` ${className}` : ""}`.trim()}>
      {stepper}

      {integrated ? (
        <div className="review-page-layout__grid">
          <div className="review-page-layout__main">{main}</div>
          <aside className="review-page-layout__sidebar" aria-label="סיכום">
            <div className="review-page-layout__sidebar-sticky">{sidebar}</div>
          </aside>
        </div>
      ) : (
        <div className="review-page-layout__flow">{children}</div>
      )}
    </div>
  );
}
